import PurchaseLedger from '@/pages/intranet/PurchaseLedger';
import PurchaseRegister from '@/pages/intranet/PurchaseRegister';
import PurchaseModify from '@/pages/intranet/PurchaseModify';
import CustomerManage from '@/pages/intranet/CustomerManage';
import CustomerRegister from '@/pages/intranet/CustomerRegister';
import CustomerModify from '@/pages/intranet/CustomerModify';

export default {
	PurchaseLedger: {
		id: 'PurchaseLedger',
		title: '매입 매출 관리',
		heading: '매입 매출 관리',
		path: '/intranet/ledger-purchase',
		component: PurchaseLedger,
	},
	PurchaseRegister: {
		id: 'PurchaseRegister',
		title: '매입 매출 등록',
		heading: '매입 매출 등록',
		path: '/intranet/purchase-register',
		component: PurchaseRegister,
	},
	PurchaseModify: {
		id: 'PurchaseModify',
		title: '매입 매출 수정',
		heading: '매입 매출 수정',
		path: '/intranet/purchase-modify/:titleId',
		component: PurchaseModify,
	},
	CustomerManage: {
		id: 'CustomerManage',
		title: '거래처 관리',
		heading: '거래처 관리',
		path: '/intranet/customer-manage',
		component: CustomerManage,
	},
	CustomerRegister: {
		id: 'CustomerRegister',
		title: '거래처 등록',
		heading: '거래처 등록',
		path: '/intranet/customer-register',
		component: CustomerRegister,
	},
	CustomerModify: {
		id: 'CustomerModify',
		title: '거래처 수정 / 삭제',
		heading: '거래처 수정 / 삭제',
		path: '/intranet/customer-modify/:titleId',
		component: CustomerModify,
	},
};
